import { useAuthStore } from '../store/auth.store';
import type { ShopCategory } from '@bienlivrer/types';

/** Compte commerçant démo : vitrine par catégorie, sans écriture. */
export function useMerchantDemo() {
  const user = useAuthStore((s) => s.user);
  const isDemoMerchant = user?.role === 'merchant' && user?.isDemo === true;
  const category = user?.demoPreviewCategory as ShopCategory | undefined | null;
  const needsCategory = isDemoMerchant && !category;
  const canPersist = !isDemoMerchant;
  /** Alias historique : true en démo (bannières, assistance). Ne plus masquer l’UI avec ce flag. */
  const readOnly = isDemoMerchant;

  return {
    isDemoMerchant,
    category: category ?? undefined,
    needsCategory,
    canPersist,
    readOnly,
  };
}
